

















































































































































import { defineComponent, reactive, toRefs, onMounted, watch, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue'
import { Student, SearchCondition } from "../../modules/teacher/ProgressStudentList"

export interface Data {
  base_sheet_id: string
  sheet_name: string
  condition: SearchCondition
  students: Student[]
  sortedStudents: Student[]
  perPage: number
  totalCount: number
  fields: any[]
  isAllCheckedDelete: boolean
  delete_student_codes: number[]
  isShowPagination: boolean
  isAllDeleteChecked: boolean
  errors: string[]
  comboboxCourse: any[]
  comboboxCampus: any[]
  comboboxClassification: any[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      base_sheet_id: null,
      sheet_name: null,
      condition: new SearchCondition(),
      students: new Array<Student>(),
      sortedStudents: new Array<Student>(),
      perPage: 100,
      totalCount: 0,
      fields: [
        {key: "student_code", label: "生徒CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "course_name", label: "コース", sortable: true, class: 'text-center b-table-th-td'},
        {key: "campus_name", label: "キャンパス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "class_name", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        {key: "kumi", label: "組", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_no", label: "出席番号", sortable: true, class: 'text-center b-table-th-td'},
        {key: "status", label: "在校状態", sortable: true, class: 'text-center b-table-th-td'},
        {key: "submitted_progress", label: "提出状況", sortable: false, class: 'text-center b-table-th-td'},
        {key: "submitted_percent", label: "提出率", sortable: true, class: 'text-center b-table-th-td'},
        {key: "scoring_count", label: "採点中", sortable: false, class: 'text-center b-table-th-td'},
        {key: "passed_count", label: "合格", sortable: false, class: 'text-center b-table-th-td'},
        {key: "failed_count", label: "再提出", sortable: false, class: 'text-center b-table-th-td'},
        {key: "passed_percent", label: "合格率", sortable: true, class: 'text-center b-table-th-td'},
        {key: "detail", label: "詳細", class: 'text-center b-table-th-td', thStyle: {width: "80px"}},
      ],
      isAllCheckedDelete: false,
      delete_student_codes: [],
      isShowPagination: false,
      isAllDeleteChecked: false,
      errors: [],
      comboboxCourse: [],
      comboboxCampus: [],
      comboboxClassification: [],
    });

    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * ソート
     ******************************/

    const onSortChanged = (sortInfo: { sortBy: string; sortDesc: boolean }) => {
      state.sortedStudents = [...state.students].sort((a: any, b: any) => {
        const key = sortInfo.sortBy;
        const order = sortInfo.sortDesc ? -1 : 1;
        return a[key] < b[key] ? -1 * order : 1 * order;
      });
    };

    /******************************
     * 全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: any) => x.is_checked = isChecked);
    };

    /******************************
     * 削除
     ******************************/

    const deleteMst = async (): Promise<void> => {

      if(state.students.filter(x => x.is_checked).length == 0){
        alert("削除対象が選択されていません。");
        return;
      }

      if(!window.confirm("削除を実行します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      const delete_ids: number[] = state.students.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/teacher/progress_student_list/delete`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      state.condition.base_sheet_id = state.base_sheet_id;
      await http.get(`/api/teacher/progress_student_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.students = response.data.students.map((x: any) => new Student(x));
        state.sortedStudents = state.students;
        state.totalCount = state.students.length == 0 ? 0 : state.students[0].full_count;
        state.comboboxCourse = Common.createComboboxOptions(response.data.result_vieable_courses, "course_code", "name", true);
        state.comboboxCampus = Common.createComboboxOptions(response.data.result_vieable_campuses, "campus_code", "name", true);
        state.comboboxClassification = Common.createComboboxOptions(response.data.result_vieable_classifications, "class_code", "name", true);
        state.sheet_name = response.data.sheet_name;
        context.root.$store.commit("setProgressStudentListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {

      state.delete_student_codes = [];

      if (newVal) {

        state.delete_student_codes = state.students.map(x => x.student_code);
      }
    });

    /******************************
     * 生徒TOP画面へ
     ******************************/

    const toStudentSheetList = (student_code: string, student_name: string) => {
      context.root.$store.commit("setStudentCode", student_code);
      context.root.$store.commit("setStudentName", student_name);
      context.root.$store.commit("setStudents", state.sortedStudents);
      if(context.root.$store.getters.isOptionLessonActive){
        context.root.$router.push(`/teacher_site/student_ref/lesson_class_list`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/student_ref/sheet_list`).catch(err => {});
      }
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.base_sheet_id = context.root.$route.params.base_sheet_id;
      state.condition = context.root.$store.state.progressStudentListCondition;
      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      search,
      clearCondition,
      changePage,
      allSelectChanged,
      deleteMst,
      toStudentSheetList,
      searchButtonClick,
      onSortChanged,
    };
  }
});

